import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomLockGroupAction: React.FC<ActionProps> = (props) => {
    return null;
};
